import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
const mockUsers = [{
  id: 1,
  name: 'Marcus Chen',
  email: 'marcus@chengroup.com',
  shortUrl: '/marcuschen',
  status: 'Active',
  role: 'Admin'
}, {
  id: 2,
  name: 'Krystle Copeland',
  email: 'krystle@eaves.pro',
  shortUrl: '/krystlecopeland',
  status: 'Active',
  role: 'Admin'
}, {
  id: 3,
  name: 'Sarah Kim',
  email: 'sarah.kim@compass.com',
  shortUrl: '/sarahkim',
  status: 'Active',
  role: 'Agent'
}, {
  id: 4,
  name: 'David Park',
  email: 'david.park@sothebys.com',
  shortUrl: '/davidpark',
  status: 'Pending',
  role: 'Agent'
}];
export function AdminUsers() {
  return <div className="p-8 max-w-6xl mx-auto" data-id="element-478">
      <div className="mb-8" data-id="element-479">
        <h1 className="text-3xl font-serif font-semibold text-brand-dark mb-2" data-id="element-480">
          All Users
        </h1>
        <p className="text-sm text-brand-muted" data-id="element-481">
          Manage registered agent profiles
        </p>
      </div>

      <div className="bg-white rounded-2xl border border-brand-light shadow-sm overflow-hidden" data-id="element-482">
        <div className="overflow-x-auto" data-id="element-483">
          <table className="w-full text-left text-sm" data-id="element-484">
            <thead className="bg-brand-offwhite border-b border-brand-light text-brand-muted" data-id="element-485">
              <tr data-id="element-486">
                <th className="px-6 py-4 font-medium" data-id="element-487">Name</th>
                <th className="px-6 py-4 font-medium" data-id="element-488">Email</th>
                <th className="px-6 py-4 font-medium" data-id="element-489">Short URL</th>
                <th className="px-6 py-4 font-medium" data-id="element-490">Status</th>
                <th className="px-6 py-4 font-medium" data-id="element-491">Role</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-492">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-brand-light" data-id="element-493">
              {mockUsers.map(user => <tr key={user.id} className="hover:bg-brand-offwhite/50 transition-colors" data-id="element-494">
                  <td className="px-6 py-4 font-medium text-brand-dark" data-id="element-495">
                    {user.name}
                  </td>
                  <td className="px-6 py-4 text-brand-muted" data-id="element-496">{user.email}</td>
                  <td className="px-6 py-4 font-mono text-brand-muted" data-id="element-497">
                    {user.shortUrl}
                  </td>
                  <td className="px-6 py-4" data-id="element-498">
                    <span className={`inline-flex items-center px-2 py-1 rounded-md text-[11px] font-medium uppercase tracking-wider ${user.status === 'Active' ? 'bg-emerald-50 text-emerald-700 border border-emerald-200' : 'bg-amber-50 text-amber-700 border border-amber-200'}`} data-id="element-499">
                      {user.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-500">
                    <span className={`inline-flex items-center px-2 py-1 rounded-md text-[11px] font-medium uppercase tracking-wider ${user.role === 'Admin' ? 'bg-brand-forest text-white' : 'bg-brand-sage text-brand-forest border border-brand-forest/20'}`} data-id="element-501">
                      {user.role}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-502">
                    <div className="flex items-center justify-end gap-3" data-id="element-503">
                      <Link to="/admin/edit" className="text-brand-forest hover:text-brand-dark font-medium transition-colors" data-id="element-504">
                        Edit
                      </Link>
                      <a href={user.shortUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-brand-muted hover:text-brand-dark transition-colors" data-id="element-505">
                        View <ExternalLink size={14} data-id="element-506" />
                      </a>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}